import { createContext } from 'react'

export const ForwardingTaskContext = createContext(undefined)
